var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 17,
    viewBox: "0 0 13 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.125 0C0.95293 0 0 0.95293 0 2.125V14.875C0 16.0471 0.95293 17 2.125 17H10.625C11.7971 17 12.75 16.0471 12.75 14.875V5.3125H8.5C7.9123 5.3125 7.4375 4.8377 7.4375 4.25V0H2.125ZM8.5 0V4.25H12.75L8.5 0ZM7.17188 7.70312V11.0932L8.20117 10.0639C8.51328 9.75176 9.01797 9.75176 9.32676 10.0639C9.63555 10.376 9.63887 10.8807 9.32676 11.1895L6.93613 13.5801C6.62402 13.8922 6.11934 13.8922 5.81055 13.5801L3.41992 11.1895C3.10781 10.8773 3.10781 10.3727 3.41992 10.0639C3.73203 9.75508 4.23672 9.75176 4.54551 10.0639L5.5748 11.0932V7.70312C5.5748 7.26152 5.93008 6.90625 6.37168 6.90625C6.81328 6.90625 7.16855 7.26152 7.16855 7.70312H7.17188Z",
    fill: "#FFCABF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.9a219093cd54594a72e811aea77ade1d.svg";
export { ForwardRef as ReactComponent };